export default __webpack_public_path__ + "static/MediaContentSeven-cfc4788aea96f1c3d28e0b21ba263e85.webp";